import React, { useEffect, useState } from "react";
import closeButton from '../../assets/images/close.png';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getApprovedWorkTypeCounts } from "../../services/AppService";
import { resolveMediaUrl } from "../../utility/media";
import PageFade from "../../components/Login/PageFade";

const PaymentWorkTypePage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [totalElements, setTotalElements] = useState(0);

    useEffect(() => {
        const fetchDashboardData = async () => {
            setLoading(true);
            try {
                const res = await getApprovedWorkTypeCounts(searchTerm, page, size);
                if (res) {
                    setData(res.content || []);
                    setTotalElements(res.totalElements || 0);
                }
            } catch (err) { console.error(err); } 
            finally { setLoading(false); }
        };
        fetchDashboardData();
    }, [page, size, searchTerm]);

    const handleViewWorkOrders = (workTypeId, workTypeName) => {
        navigate(`/smartcity/accounts/payment/${workTypeId}`, {
            state: { workTypeName }
        });
    };

    return (
        <PageFade>
            <div className="bg-white shadow-lg rounded-2xl p-6">
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h4 className="text-xl font-semibold text-blue uppercase tracking-wide">
                        {t('pageTitles.paymentList') || "Add / Edit Payment"}
                    </h4>
                    <img src={closeButton} alt="Close" className="w-6 h-6 cursor-pointer" onClick={() => navigate(-1)} />
                </div>

                <div className="flex justify-between items-center mb-4">
                    <div className="flex items-center gap-2 text-sm">
                        <label>{t('common.show')}:</label>
                        <select value={size} onChange={(e) => setSize(Number(e.target.value))} className="border rounded px-2 py-1 outline-none">
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                        </select>
                    </div>
                    <input
                        type="text"
                        placeholder={t('common.search')}
                        className="border rounded px-3 py-1 text-sm outline-none w-64"
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className="overflow-x-auto rounded-xl border border-gray-100 shadow-sm">
                    <table className="w-full border text-sm ctable">
                        <thead className="bg-[#a0adf1] text-white">
                            <tr>
                                <th className="px-3 py-2 text-center border-b border-black w-16">{t('tables.srNo')}</th>
                                <th className="px-3 py-2 text-center border-b border-black">{t('forms.planEstimate.workType')}</th>
                                <th className="px-3 py-2 text-center border-b border-black w-32">{t('common.total')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="3" className="text-center p-10">{t('common.loading')}...</td></tr>
                            ) : data.length === 0 ? (
                                <tr><td colSpan="3" className="text-center py-20 italic text-gray-500">{t('common.noRecords')}</td></tr>
                            ) : (
                                data.map((item, idx) => (
                                    <tr key={item.id} className="hover:bg-blue-50 border-b">
                                        <td className="px-3 py-4 text-center border-r">{page * size + idx + 1}</td>
                                        <td className="px-3 py-2 border-r">
                                            <div className="flex items-center gap-4 pl-10">
                                                {item.workImageUrl && <img src={resolveMediaUrl(item.workImageUrl)} alt="" className="w-10 h-10 object-contain" />}
                                                <span className="font-medium text-gray-700 uppercase">{item.workTypeName}</span>
                                            </div>
                                        </td>
                                        <td className="px-3 py-2 text-center">
                                            <button
                                                onClick={() => handleViewWorkOrders(item.id, item.workTypeName)}
                                                className="bg-[#3182ce] text-white font-bold w-10 h-10 rounded-full hover:bg-blue-700 shadow-md flex items-center justify-center mx-auto"
                                            >
                                                {item.totalEstimates || 0}
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </PageFade>
    );
};

export default PaymentWorkTypePage;